// extracted by mini-css-extract-plugin
export var buttons = "_4l-0";
export var buttonsActive = "_4l-h";
export var cancelConfirm = "_4l-1";
export var closeButton = "_4l-2";
export var column = "_4l-3";
export var container = "_4l-4";
export var detailHeader = "_4l-6";
export var detailTitle = "_4l-7";
export var detailsContent = "_4l-5";
export var header = "_4l-8";
export var headerWithClose = "_4l-9";
export var icon = "_4l-a";
export var infoIcon = "_4l-c";
export var informationContainer = "_4l-b";
export var sideDrawer = "_4l-d";
export var sideDrawerOpen = "_4l-e";
export var stickyFooter = "_4l-f";
export var typeOption = "_4l-g";